import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import makeStyles from '@mui/styles/makeStyles';
import TriageDetailsPopover from './TriageDetailsPopover';

const useStyles = makeStyles(theme => ({
    underline: {
        textDecoration: ({ textType } : any ) => textType === 'string' ? 'underline' : 'none',
        color: "#2739c1",
    },
 
}));

export default function TriagePopoverLink({ rowData = undefined, columnData, customClasses = '', hoverData, title = '', tabIndex = undefined }) {
    
    const [anchorEl, setAnchorEl] = useState(null);
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);
    const [popoverTitle, setPopoverTitle] = useState('');
    const classes = useStyles({ textType: typeof columnData });


    function handleHoverColumn(event, rowData) {
        setAnchorEl(event?.target);
        setPopoverTitle(title);
        setIsPopoverOpen(true);
    }

    function popoverLeave() {
        setIsPopoverOpen(false);
    }

    function paperEnter() {
        setIsPopoverOpen(true);
    }


    return (
        <>
            <Link
                to=""
                onClick={(e) => e.preventDefault()}
                aria-owns={`${columnData}-mouse-over-popover`}
                aria-haspopup="true"
                onMouseEnter={(event) => handleHoverColumn(event, rowData)}
                onMouseLeave={popoverLeave}
                className={` ${customClasses} ${classes.underline}`}
                tabIndex={tabIndex}
            >
                {`${columnData} %`}{" "}
            </Link>
           {hoverData && <TriageDetailsPopover
                columnData={columnData}
                items={hoverData}
                title={popoverTitle}
                isPopoverOpen={isPopoverOpen}
                anchorEl={anchorEl}
                actions={{
                    popoverLeave,
                    paperEnter
                }}
            />}
        </>
    );
}